module.exports = __webpack_public_path__ + "static/media/Image.62b27cd5.png";